import React, { useState } from 'react'
import { Link, useForm, usePage } from '@inertiajs/inertia-react'
import AlertDismissible from '../../../Shared/Components/AlertDismissible'
import Breadcrumbs from '../../../Shared/Components/Breadcrumbs'
import FormValidationSummary, { mergeValidationErrors, validationMessage } from '../../../Shared/Components/FormValidationSummary'
import Layout from '../../../Shared/Layout/LayoutAdmin'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'

const Reqd = () => <span className="text-danger">*</span>

const ClaimTestimonialForm = ({ entry, offices }) => {
    const { flash, errors: pageErrors } = usePage().props
    const isEdit = Boolean(entry)
    const [saving, setSaving] = useState(false)

    const form = useForm({
        insured_name: entry?.insured_name || '',
        video_date: entry?.video_date ? String(entry.video_date).slice(0, 10) : '',
        story: entry?.story || '',
        youtube_video_id: entry?.youtube_video_id || '',
        office_id: entry?.office_id ? String(entry.office_id) : '',
    })

    const allErrors = mergeValidationErrors(form.errors, pageErrors)
    const fieldError = (key) => validationMessage(allErrors, key)
    const invalidClass = (key) => (fieldError(key) ? 'is-invalid' : '')

    const submit = (e) => {
        e.preventDefault()
        setSaving(true)
        const opts = { preserveScroll: true, onFinish: () => setSaving(false) }
        if (isEdit) {
            form.put(route('claims.testimonials.update', entry.id), opts)
        } else {
            form.post(route('claims.testimonials.store'), opts)
        }
    }

    return (
        <Row>
            {flash?.success && <AlertDismissible message={flash.success} type="success" />}
            <FormValidationSummary errors={allErrors} />
            <Col xs={12}><Breadcrumbs currentPath={isEdit ? `admin/claims/testimonials/${entry.id}/edit` : 'admin/claims/testimonials/create'} /></Col>
            <Col xs={12} md={8} className="mx-auto">
                <Card>
                    <Card.Header><Card.Title className="fw-bold">FORMULARIO DE {isEdit ? 'ACTUALIZACIÓN' : 'REGISTRO'}</Card.Title></Card.Header>
                    <Card.Body>
                        <Form onSubmit={submit}>
                            <Form.Group className="mb-4">
                                <Form.Label className="fw-bold">Nombre <Reqd /></Form.Label>
                                <Form.Control value={form.data.insured_name} onChange={(e) => form.setData('insured_name', e.target.value)} className={invalidClass('insured_name')} />
                                {fieldError('insured_name') && <div className="text-danger fs-8">{fieldError('insured_name')}</div>}
                            </Form.Group>
                            <Form.Group className="mb-4">
                                <Form.Label className="fw-bold">Fecha <Reqd /></Form.Label>
                                <Form.Control type="date" value={form.data.video_date} onChange={(e) => form.setData('video_date', e.target.value)} className={invalidClass('video_date')} />
                            </Form.Group>
                            <Form.Group className="mb-4">
                                <Form.Label className="fw-bold">Historia del video <Reqd /></Form.Label>
                                <Form.Control as="textarea" rows={6} value={form.data.story} onChange={(e) => form.setData('story', e.target.value)} className={invalidClass('story')} />
                            </Form.Group>
                            <Form.Group className="mb-4">
                                <Form.Label className="fw-bold">ID del video de YouTube <Reqd /></Form.Label>
                                <Form.Control value={form.data.youtube_video_id} onChange={(e) => form.setData('youtube_video_id', e.target.value)} placeholder="Solo lo que sigue después de v=" className={invalidClass('youtube_video_id')} />
                                <Form.Text>Solo el ID, p. ej. aDNQGngbfGA</Form.Text>
                            </Form.Group>
                            <Form.Group className="mb-4">
                                <Form.Label className="fw-bold">Oficina <Reqd /></Form.Label>
                                <Form.Select value={form.data.office_id} onChange={(e) => form.setData('office_id', e.target.value)} className={invalidClass('office_id')}>
                                    <option value="">Seleccione...</option>
                                    {offices.map((o) => <option key={o.id} value={o.id}>{o.nombre}</option>)}
                                </Form.Select>
                            </Form.Group>
                            <div className="d-flex flex-column align-items-center gap-3">
                                <Button type="submit" disabled={saving || form.processing}>{isEdit ? 'Actualizar' : 'Guardar'}</Button>
                                <Link href={route('claims.testimonials.index')} className="btn btn-light">Regresar</Link>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}

ClaimTestimonialForm.layout = (page) => <Layout title="Video testimonial">{page}</Layout>

export default ClaimTestimonialForm
